import type { CSSProperties } from 'react';
import type { DeckShoeVM } from '@tv-casino/viewmodels/components/deckShoeModel.js';
import styles from './DeckShoe.module.css';

/** Card index in the stack, as the CSS custom property the layout reads. */
const at = (i: number) => ({ '--i': i }) as CSSProperties;

/**
 * The deck sitting in its shoe at the corner of the felt, where the cards on
 * the table deal in from. The stack is drawn, not counted: its thickness
 * tracks how much of the shoe is left, and the cut card shows at the mouth
 * once the shoe is spent.
 */
export function DeckShoe({ vm, className = '' }: { vm: DeckShoeVM; className?: string }) {
  const classes = [styles.shoe, vm.low ? styles.low : '', className].filter(Boolean).join(' ');
  return (
    <figure className={classes} aria-label={vm.ariaLabel}>
      <div className={styles.housing} aria-hidden="true">
        <div className={styles.stack}>
          {/* Edges first, then the back of the top card riding on them. */}
          {Array.from({ length: vm.layers }, (_, i) => (
            <span key={i} className={styles.edge} style={at(i)} />
          ))}
          {vm.layers > 0 && <span className={styles.face} style={at(vm.layers)} />}
        </div>
        {/* The slot the dealer draws through. */}
        <span className={styles.mouth} />
      </div>
      <figcaption className={styles.plate}>
        <span className={styles.label}>{vm.label}</span>
        <span className={styles.note}>{vm.note}</span>
      </figcaption>
    </figure>
  );
}
